import React from 'react';
import { Typography } from '@material-ui/core';

import { BaseItem } from '../BaseItem';
import { GenerationToolItem } from '../GenerationToolItem';

export const FreestyleDetails = ({
  className,
  generationData,
  displayGenerationTool,
  vertical,
  baseItemClasses,
}) => {
  const { freestyleToolAllInstructions } = generationData;

  return (
    <>
      {displayGenerationTool && (
        <Typography className={className}>
          <GenerationToolItem
            generationData={generationData}
            vertical={vertical}
          />
        </Typography>
      )}

      <Typography className={className}>
        <BaseItem
          label="instructions"
          vertical={vertical}
          classes={baseItemClasses}
          hideTitleColon
        >
          {freestyleToolAllInstructions}
        </BaseItem>
      </Typography>
    </>
  );
};
